import React, { useState, useEffect } from 'react';
import linkIcon from '../../../assets/images/link.svg'
import { fetchOrderById } from '../../../redux/orderSlice.js'; // Import actions from the slice
import { useSelector, useDispatch } from 'react-redux';
import MainTable from '../../../components/Table/PaginationTable.js';
import { ProductColumnDefForeReviewOrder } from '../columns/columnDef.js';
import { useParams,useNavigate } from 'react-router-dom';
import placeOrderIcon from '../../../assets/images/Order-place.svg'
import DeclineModalComponent from '../../../components/Modals/DeclineModalComponent.js';
import CreateTagRequest from '../CreateTagRequest/CreateTagRequest.js';
import { getDate } from '../../../helpers/helperFunction.js';


const OrderDetails = () => {
    // const orderDetails = useSelector((state) => console.log('@@@@:',state))
    const productData = useSelector(state =>
        state.order.orderDetails && state.order.orderDetails.data && state.order.orderDetails.data.orderProducts
            ? state.order.orderDetails.data.orderProducts
            : []);
    const orderDetails = useSelector((state) => state.order.orderDetails?.data || {});
    const companyRole = useSelector((state) => state.auth.userDetails?.company?.companyRoles || []);
    const dispatch = useDispatch();
    const navigate = useNavigate()
    const { orderId } = useParams();
    const productColumn = ProductColumnDefForeReviewOrder();
    const [isCancelModalOpen, setIsCancelModalOpen] = useState(false);

    const handleLinkCloseModal = () => setLinkModalOpen(false);

    const [showCreateRequestTag, setShowCreateRequestTag] = useState(false);

    const handleCreateRequestTag = () => {
      setShowCreateRequestTag(true);
    };
  

    useEffect(() => {
        dispatch(fetchOrderById(orderId));

    }, [dispatch,orderId]);

    if (showCreateRequestTag) {
        // Render the CreateRequestTag component if showCreateRequestTag is true
        return <CreateTagRequest order = {orderDetails}/>;
    } else {
        return (
       
            <>
                <div className="card mt-3 bg-stage">
                    <div className="card-body">
                        <div>
                            <h1 className="fprimary">Review Order </h1>
                            <h5 className="">Review the Order</h5>
                        </div>
                        <div className="row">
                            <div className="col-md-4">
                                <div className="d-flex justify-content-between indect">
                                    <div className="left-box w-100 border-end pe-2">
                                        <p className="font-13 mb-0">Purchase Order</p>
                                        <div className="bg-slash font-14">{orderDetails.orderNumber}</div>
                                    </div>
                                    <div className="ps-2 right-box w-100">
                                        <p className="font-13 mb-0">Supplier</p>
                                        <div className="bg-slash font-14">{orderDetails.supplierCompany?.companyName || 'N/A'}</div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="d-flex justify-content-between indect">
                                    <div className="left-box w-100 border-end pe-2">
                                        <p className="font-13 mb-0">Order Date</p>
                                        <div className="bg-slash font-14">{getDate(orderDetails.orderDate)}</div>
                                    </div>
                                    <div className="ps-2 right-box w-100">
                                        <p className="font-13 mb-0">Order Due Date</p>
                                        <div className="bg-slash font-14">{getDate(orderDetails.orderExpectedDate)}</div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="d-flex justify-content-between indect">
                                    <div className="left-box w-100 pe-2">
                                        <p className="font-13 mb-0">Link Buyer Purchase Order</p>
                                        <div className="bg-slash font-14">{orderDetails.linkedOrderNumber}</div>
                                        <span className="ms-2"><img src={linkIcon} alt="Link" /></span>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-12">
                                <div className="mt-3">
                                    <h4 className="font-18">Order Description</h4>
                                    <p className="font-13">
                                        {orderDetails.orderDescription}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* <div className="card mt-3 bg-stage">
                    <div className="card-body"> */}
    
                    {/* </div>
                </div> */}
    
                </div>
                <div className='mt-5 ml-2'>
                    <h1 className="fprimary">Product Details</h1>
                </div>
                <MainTable
                    columns={productColumn}
                    data={productData}
                    enablePagination={false}
                    className='mt-5'
                />
    
                <div>
                    <div className="d-flex justify-content-between">
                        <button type="button" className="btn btn-light grey-btn lg-btn mt-4" onClick={()=>navigate(-1)}>Back</button>
                        {orderDetails.orderStatus === "Fulfilled" && companyRole === 'GM' && (  // TODO: To show Request Tag button only if tag is not already requested.
                            <button
                                type="button"
                                className="btn btn-primary green-btn lg-btn mx-3"
                                style={{ width: "17%", height: "10%", marginTop: "2%", fontSize: "small", backgroundColor: "green" }}
                                onClick={handleCreateRequestTag}
                            >
                                Request Tags
                            </button>
                              )}
                    </div>
                </div>
               
            </>
        );
    }
    
};

export default OrderDetails;
